"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReferenceNumberStartWith = exports.ReferenceType = void 0;
var ReferenceType;
(function (ReferenceType) {
    ReferenceType["CAR_PURCHASE"] = "CAR_PURCHASE";
    ReferenceType["CUSTOMER_INVOICE"] = "CUSTOMER_INVOICE";
    ReferenceType["CUSTOMER_CREDIT_INVOICE"] = "CUSTOMER_CREDIT_INVOICE";
    ReferenceType["EYESHARE_INVOICE"] = "EYESHARE_INVOICE";
    ReferenceType["IFS_INTERNAL_INVOICE"] = "IFS_INTERNAL_INVOICE";
    ReferenceType["IMPORTER_INVOICE"] = "IMPORTER_INVOICE";
    ReferenceType["MANUAL_CORRECTION"] = "MANUAL_CORRECTION";
    ReferenceType["SERVICE_ORDER"] = "SERVICE_ORDER";
})(ReferenceType = exports.ReferenceType || (exports.ReferenceType = {}));
var ReferenceNumberStartWith;
(function (ReferenceNumberStartWith) {
    ReferenceNumberStartWith["CD"] = "CD";
    ReferenceNumberStartWith["CR"] = "CR";
})(ReferenceNumberStartWith = exports.ReferenceNumberStartWith || (exports.ReferenceNumberStartWith = {}));
//# sourceMappingURL=margins.js.map